import { useMenuButton, useSlotProps } from '@mui/base';
import { forwardRef } from 'react';

import { Button } from '../../../buttons';

import type { MenuButtonProps } from './menu-button.types';

const MenuButton = forwardRef((props: MenuButtonProps, forwardedRef: React.Ref<HTMLButtonElement>): JSX.Element => {
  const { children, disabled = false, htmlType, type, ...other } = props;

  const { getRootProps } = useMenuButton({
    disabled,
    focusableWhenDisabled: false,
    rootRef: forwardedRef,
  });

  const Root = Button;

  const { ownerState, ...rootProps } = useSlotProps({
    additionalProps: {
      ref: forwardedRef,
    },
    elementType: Root,
    externalForwardedProps: other,
    externalSlotProps: undefined,
    getSlotProps: getRootProps,
    ownerState: undefined,
  });

  return (
    <Button {...rootProps} htmlType={htmlType} type={type}>
      {children}
    </Button>
  );
});

MenuButton.displayName = 'MenuButton';

export default MenuButton;
